





















































import Vue from 'vue'
export default Vue.extend({
  ...{
    props: {
      value: {type: Boolean, default: false},
      orderId: {type: String, default: ""}
    },
    data() {
      return {
        claimReasonId: null,
        userInputReason: null,
        claimError: false,
      }
    },
    methods: {
      resetClose() {
        this.claimError = false;
        this.claimReasonId = null;
        this.userInputReason = null;
        this.$emit("hide-dialog");
      },
      getClaimReason() {
        if (this.claimReasonId === 1)
          return 'Keine Entsorgung'
        if (this.claimReasonId === 2)
          return 'Teilweise Entsorgung'
        if (this.claimReasonId === 8)
          return 'Falsche Leistung'
        return 'Sonstiges'
      },
      claimOrder() {
        if (this.claimReasonId == null) {
          this.claimError = true;
          return;
        }
        this.$store
          .dispatch("claimOrder", {
            orderId: this.orderId,
            claimReasonId: this.claimReasonId,
            userInputReason: this.userInputReason,
          })
          .then(() => {
            this.$toast("Der Auftrag wurde wunschgemäß reklamiert.", {
              timeout: 5000,
            });
            if (this.$cookies.isAccepted()){
              (this as any).$gtag.event('order-claim', {
                'event_category': 'order',
                'event_label': this.getClaimReason()
              })
            }
            this.$emit("refresh-history");
          })
          .catch((e) => {
            this.$toast.error(e.response.data.error.message);
          });
        this.resetClose()
      },
    },
  },
})
